namespace Portico.Models.Enterprise {
	import psgm = apigateway.models;

    export interface IApplication {
		name: string;
        description: string;
        lifetime: number;
    }

	export class Application implements IApplication {
		name: string;
		description: string;
		lifetime: number;

        constructor(obj?: IApplication | any) {
			this.name = '';
			this.description = '';
			this.lifetime = 60;

            if (obj) {
				this.name = obj.name || '';
				this.description = obj.description || '';
				this.lifetime = obj.lifetime || 60;
            }
        }
    }
}
